<template>
  <div class="p-4">
    <div class="row">
      <h4>Import Track Log</h4>


      <b-row class="my-1" >
<!--        <b-col sm="6">
          <label>Custom layer name</label>
        </b-col>
        <b-col sm="6">
          <b-form-input  v-model="selectedLayerTitle" placeholder="Layer title"></b-form-input>
        </b-col>-->
      </b-row>
    </div>
    <div class="row">
      <file-uploader :validFn="validateUploadFile" ref="fUploader"  v-model="uploadedFile"></file-uploader>
    </div>
    <div class="row d-flex justify-content-end">
      <b-link class="mr-2 mt-2" href="#"  @click.prevent="showHistoryData" v-b-tooltip.hover.auto title="Manage track history">
        Tracklock History
      </b-link>

      <b-btn :disabled="!uploadedFile" @click="save" v-b-tooltip.hover.auto title="Import data into the layer">
        <icon name="save"></icon>
        Upload WIP data
      </b-btn>
    </div>
    <div class="row d-flex justify-content-start">
      <h4>Import Survey Data</h4>
    </div>

    <div class="row border-top">
      <file-uploader :ext="['application/zip']" ref="fUploaderRef"  v-model="uploadedFileRef"></file-uploader>
    </div>

    <div class="row d-flex justify-content-end">
      <b-btn :disabled="!uploadedFileRef" @click="saveRef" v-b-tooltip.hover.auto title="Import data into the layer">
        <icon name="save"></icon>
        Upload ref data
      </b-btn>
    </div>

    <loading-overlay :show="loading"></loading-overlay>

    <b-modal v-model="showRefReport" no-close-on-backdrop no-close-on-esc
             :rows="3" :max-rows="5">

      <div slot="modal-header" class="w-100 release-header">
        <div class="release-notes-title">Import Summary</div>
      </div>
      <div class="release-notes-container">

        <table class="table table table-xs table-hover">
          <thead>
          <tr>
            <th>#</th>
            <th>Table Name</th>
            <th>Status</th>
            <th>Created</th>
            <th>Notes</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, i) in refReportData" :class="{'text-danger': item.status !== 'OK'}">
            <td>{{i}}</td>
            <td>{{item.name}}</td>
            <td>{{item.status}}</td>
            <td v-html="item.created ? 'Yes' : '' "></td>
            <td >
              <a href="#"  v-if="!!item.notes" @click.stop="showNotes($event, item.notes)">
                view...
              </a>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div>
        {{reportNotesMessage}}
      </div>
      <div slot="modal-footer" class="w-100 release-footer">

        <b-btn size="sm" class="float-right" variant="primary" @click="showRefReport = false">
          Close
        </b-btn>
      </div>
    </b-modal>


    <b-modal ok-only no-close-on-backdrop no-close-on-esc v-model="showHD" title="Tracklog History"  @cancel="onCancelHistory">
      <div slot="modal-header">
        <label>Tracklog History</label>
      </div>
      <div class="p-2">
        <b-table fixed hover small :items="historyData" :fields="fields" >

        </b-table>
        <loading-overlay :show="loading"></loading-overlay>
      </div>
    </b-modal>


  </div>
</template>

<script>
import FileUploader from '../FileUploader'
import LoadingOverlay from '../LoadingOverlay'
export default {
  name: 'FieldImport',
  components: {LoadingOverlay, FileUploader},
  computed: {
    currentProject () {
      return this.$store.getters['project/currentProject']
    }
  },
  data:  () => {
    return {
      showRefReport: false,
      reportNotes: false,
      reportNotesMessage: '',
      refReportData: [

      ],
      iLayers: [],
      opts: [],
      selectedLayer: 0,
      selectedLayerTitle: null,
      uploadedFile: null,
      uploadedFileRef: null,
      loading: false,
      fields: [
        { key: 'id', label: '#ID', sortable: true },
        { key: 'notes', label: 'Feature Type', sortable: true },
        { key: 'upload_date', label: 'Upload Date', sortable: true },
        { key: 'upload_user', label: 'Upload User', sortable: true },
        { key: 'created_by_user', label: 'Created By', sortable: true },
        { key: 'created_date', label: 'Created Date', sortable: true }
        /*, { key: 'clean_filename', label: 'Filename', sortable: true } */
      ],
      historyData: [],
      showHD: false,
    }
  },
  mounted () {

  },
  watch: {
    selectedLayer (val) {
      let o = this.opts.filter(d => d.value === val)[0]
      this.selectedLayerTitle = o.text
    }
  },
  methods: {
    showHistoryData(e) {
      e.preventDefault()
      this.loadHistiryData()
      this.showHD = true
    },
    loadHistiryData() {
      this.loading = true
      this.$http.get('/api/layers/get-upload-data', {
        params: {
          workpack_id: this.$store.getters['project/currentProject'].workpack.id
        }
      }).then(res => {
        this.historyData.splice(0, this.historyData.length)
        this.historyData.push.apply(this.historyData, res.body)
        this.loading = false
      }, res => {
        this.$notify({
          title: 'ERROR',
          text: 'Could not load history data',
          type: 'error'
        })
        this.loading = false
      })
    },
    onOkHistory() {

    },
    onCancelHistory() {

    },
    validateUploadFile(file, done) {
      console.log(file)
      if (file.name.toLowerCase().includes('.zip') || file.name.toLowerCase().includes('.kml')) {
        done()
      } else {
        done('Only KML or ZIP (with shapefiles) can be provided')
      }
    },
    showNotes(e, text) {
      e.preventDefault()
      this.reportNotes=true;
      this.reportNotesMessage=text
    },
    save () {
      let workpack_id = this.currentProject.workpack.id
      if (!workpack_id) {
        this.$notify({
          title: 'ERROR',
          text: 'Workpack id must be specified',
          type: 'error'
        })
        return
      }
      this.loading = true
      //import-field-data
      this.$http.post('/api/layers/import-field-data/', {
        filepath: this.uploadedFile,
        layerData: {
          'title': this.selectedLayerTitle
        },
        workpack_id: workpack_id
      }).then(res => {
        let response = res.body
        console.log(response)
        if (response['status'] ==='error') {
          this.$notify({
            title: 'ERROR',
            text: 'Could not import data',
            type: 'error'
          })
        } else {
          this.$refs.fUploader.clean()
          this.uploadedFile = null
          this.selectedLayer = 0
          this.$notify({
            title: 'Info',
            text: 'Data successfully imported',
            type: 'info'
          })

          this.loading = false

          this.loadHistiryData()
        }
      }, () => {
        this.$notify({
          title: 'ERROR',
          text: 'Unknown error',
          type: 'error'
        })
        this.loading = false
      })
    },
    saveRef () {
      this.loading = true
      //import-field-data
      this.$http.post('/api/layers/import-field-data-ref/', {
        filepath: this.uploadedFileRef
      }).then(res => {
        let response = res.body
        console.log(response)
        /*if (response['status'] ==='error') {
          this.$notify({
            title: 'ERROR',
            text: 'Could not import ref data',
            type: 'error'
          })
        } else {
          this.$refs.fUploaderRef.clean()
          this.uploadedFileRef = null
          this.$notify({
            title: 'Info',
            text: 'Ref data successfully imported',
            type: 'info'
          })
          this.loading = false
        }*/

        this.loading = false
        this.refReportData.splice(0, this.refReportData.length)
        this.refReportData.push.apply(this.refReportData, response)
        this.showRefReport = true
      }, () => {
        this.$notify({
          title: 'ERROR',
          text: 'Unknown error',
          type: 'error'
        })
        this.loading = false
      })
    },
    loadImportLayers() {
      this.$http.get('/api/layers/list-importable-tables')
        .then(res => {
          res.body.forEach(b => {
            this.iLayers[b.id] = b
          })

          this.opts.splice(0, this.opts.length)
          this.opts.push.apply(this.opts, res.body.map(r => {
            return {
              value: r['id'],
              text: r['title']
            }
          }))

          this.opts.unshift({
            value: 0,
            text: 'Please, choose layer to import data into'
          })

          console.log(res.body)
        }, r => {
          alert('ERROR: could not load data')
        })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/projectboard/FieldImport.vue